// react-ga4 for GA4 setup
import ReactGA from 'react-ga4';
import CONSTANTS from './Constants.js';

// Initialize GA4 with configuration
ReactGA.initialize(process.env.REACT_APP_GA_PROP_ID, {
	gtagOptions: {
		cookie_domain: CONSTANTS.GA.COOKIE_DOMAIN,
		anonymize_ip: CONSTANTS.GA.ANONYMIZE_IP,
		allow_google_signals: false,
		allow_ad_personalization_signals: false
	}
});

// Set custom properties
const set = (properties) => {
	ReactGA.set(properties);
};

// Track page views
const pageview = (path) => {
	ReactGA.send({ 
		hitType: "pageview", 
		page: path 
	});
};

// Track events
const event = ({ category, action, label, value }) => {
	ReactGA.event({
		category,
		action,
		label,
		value
	});
};

// GA4 doesn't use the old autotrack plugins the same way
// Enhanced measurement in GA4 handles most of what autotrack did
// Custom events can be tracked using the event() function above

// Export the ReactGA instance and helper functions
export default {
	...ReactGA,
	set,
	pageview,
	event
};